var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

var MobileNumberInput = function MobileNumberInput(props) {
    return React.createElement(IntlTelInput, props);
};

MobileNumberInput.defaultProps = _extends({}, IntlTelInput.defaultProps, {
    containerClassName: "intl-tel-input",
    inputClassName: "form-control rounded-0 shadow-0 input-control"
});
export default MobileNumberInput;